import { render, staticRenderFns } from "./aRecovery.vue?vue&type=template&id=a64bc014&"
import script from "./aRecovery.vue?vue&type=script&lang=js&"
export * from "./aRecovery.vue?vue&type=script&lang=js&"
import style0 from "./aRecovery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports